import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GridContainer, GridItem, useGuidaUIStates } from '@inter-ikea-guida/framework';
import { useIsMetricMeasures } from '../../hooks/useIsMetricMeasures';
import { getCMSState, getFormState } from '../../store/app/selectors';
import { getTranslation } from '../../store/i18n/selectors';
import { CORNER_WALL, SELECT, SLIDING, TOGGLE } from '../../utils';
import { getSingleSurveyPayload } from '../../utils/insights/getSurveyPayload';
import { sendInsightsEvent } from '../../utils/insights/sendInsights';
import { InlineMessage } from '../quiz/QuizInlineMessage';
import { FilterSelect } from './FilterSelect';
import { FilterToggle } from './FilterToggle';
import { ReadOnlyFormOption } from './ReadOnlyFormOption';
import { StyledForm } from './styles';
import { handleSlidingDoorsWidth } from './utils';
export const SingleWallForm = (props) => {
    const translate = useSelector(getTranslation);
    const formState = useSelector(getFormState);
    const cmsState = useSelector(getCMSState);
    const useMetricMeasures = useIsMetricMeasures();
    const { isCompact } = useGuidaUIStates();
    const filterTypes = [TOGGLE, SELECT];
    const onSelect = (id, value, type, selectedIndex) => {
        props.selectOption(id, value, type, selectedIndex);
        sendInsightsEvent('whatIsMe', 'select_survey_option', getSingleSurveyPayload(id, value));
    };
    useEffect(() => {
        if (formState.door_type === SLIDING) {
            handleSlidingDoorsWidth(formState, cmsState, props.selectOption);
        }
    }, [cmsState, formState, formState.door_type, formState.size_width, props.selectOption]);
    return (_jsx(StyledForm, { "$shouldAnimate": props.shouldAnimate && !isCompact, children: _jsx(GridContainer, { columns: 4, children: cmsState.form
                .filter(item => filterTypes.includes(item.type))
                .filter(item => item.valid !== CORNER_WALL)
                .map((item, index) => {
                const { type, label, options, id } = item;
                switch (type) {
                    case TOGGLE: {
                        return (_jsxs(GridItem, { columnSpan: { s: 4 }, children: [options.length > 1 ? (_jsx(FilterToggle, { label: translate(label), dataTestId: `${type}-${id}`, options: options, useMetricMeasures: useMetricMeasures, formState: formState, formObjectId: id, onClick: onSelect }, index)) : (_jsx(ReadOnlyFormOption, { label: label, option: options[0] })), id === 'size_height' && _jsx(InlineMessage, {})] }, index));
                    }
                    case SELECT: {
                        return (_jsx(GridItem, { columnSpan: { s: 4 }, children: _jsx(FilterSelect, { formState: formState, formStateId: id, index: index, label: translate(label), options: options, onValueChange: onSelect, useMetricMeasures: useMetricMeasures }, `select-container-${index}`) }, `select-container-${index}`));
                    }
                    default:
                        return _jsx(_Fragment, {});
                }
            }) }) }));
};
//# sourceMappingURL=SingleWallForm.js.map